import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

import GalleryFilters from 'Components/layout/GalleryFilters';

export default class GalleryHeader extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        filters: PropTypes.objectOf(
            PropTypes.shape({
                options: PropTypes.arrayOf(
                    PropTypes.shape({
                        value: PropTypes.string.isRequired,
                        label: PropTypes.string.isRequired
                    })
                )
            })
        ),
        header: PropTypes.element,
        onFiltersChange: PropTypes.func
    };
    static defaultProps = {
        filters: null,
        header: '',
        onFiltersChange: () => true
    }

    render() {
        const { header, filters, onFiltersChange, location } = this.props;

        if (!header && !filters) return null;
        return (
            <header className="component-gallery-header clearfix">
                {!header ? null : <div className="custom-header">{header}</div>}
                {filters ? <div className="filters-container"><GalleryFilters filters={filters} onFiltersChange={onFiltersChange} location={location} /></div> : null}
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryHeader/index.js